export default __webpack_public_path__ + "static/media/loader.833e6248.svg";